import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPpiConfigurations } from '../ActionCreators'
import { getEnabledDeveloperFeature } from '../../VNConfigurations/Selectors'

export const VNPPI = () => {
  const dispatch = useDispatch()

  // this code is just a single spot to show how to use this selector and to
  // log out into the console if it is enabled or disabled. Keep this log for production.
  const isDeveloperFeatureEnabled = useSelector((state) => getEnabledDeveloperFeature(state))
  // eslint-disable-next-line no-console
  console.log(`DEVELOPER FEATURE ENABLED: ${isDeveloperFeatureEnabled}`)

  useEffect(() => {
    dispatch(getPpiConfigurations())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}
